import { actions } from "./title.actions";
import { selectors } from "./title.selectors";

export const title = {
  actions: actions,
  selectors: selectors,
};
